import React from 'react';
import { formatoDecimal } from '../../utilities/formatoNumeros';

export default class TipoPublicacionesListItem extends React.Component {

  render = () => {

    const { codigo, descripcion, comision } = this.props;

    return (
      <div className="list-group-item hover-background-color">
        <div className="row justify-content-evenly">

          <div className="col-1">
            <h6 className="box-title m-b-5 font-weight-bold">{codigo}</h6>
          </div>
            
          <div className="col-9 col-md-6 text-break">
            <small className="font-14 applyFont">{descripcion}</small><br/>
          </div>
                  
          <div className="col-2">
            <small className="font-14 applyFont">
              {formatoDecimal(comision)} 
              <i className="fas fa-percent d-inline-block mx-1"/>
            </small>
          </div>

        </div>
      </div>
    );
  }
}